import React from 'react';
import cx from 'classnames';

import {  Col, Row } from 'react-bootstrap';
import styles from '../../FliteviewSettingsView.module.scss';
import ColorPicker from '../../../../../components/ColorPicker';
import { localizedStrings } from '../../../../../../localization';

import _ from 'lodash';

class Theme extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

        this.localizedCustomisedTheme = localizedStrings.pages.settings.account.viewer_settings.customize_theme;
    }

  handlePrimaryColorChange(hexColor){
    this.props.onThemeChange({
      primaryColor: hexColor
    });
  }
  
  handleButtonTextColorChange(hexColor){
    this.props.onThemeChange({
      buttonTextColor: hexColor
    });
  }

  render() {
    let primaryColor = _.get(this.props.librarySettings, `primaryColor`);
    let buttonTextColor = _.get(this.props.librarySettings, `buttonTextColor`);

    return (
      <div>
        <div className={styles.title}>{this.props.title}</div>
        <div className={styles.description}>{this.props.description}</div>
        <Row className={cx(styles.themeOptions, styles.column)} >

            <Col md={4} lg={4} xl={4} className={styles.column}>
                <ColorPicker title={this.localizedCustomisedTheme.primary_color} hexColor={primaryColor} onColorChange={this.handlePrimaryColorChange.bind(this)}/>
            </Col>
            <Col md={4} lg={4} xl={4} className={styles.column}>
                <ColorPicker title={this.localizedCustomisedTheme.button_text_color} hexColor={buttonTextColor} onColorChange={this.handleButtonTextColorChange.bind(this)}/>
            </Col>
        </Row>
      </div>
    );
  }
}

export default Theme;